import { TFunction } from 'i18next';

import { NAVBAR_MENU_KEYS } from '../constants/keys';

const ROLE_KEY_MAP: Record<string, string> = {
  Employee: NAVBAR_MENU_KEYS.roles.employee,
  Candidate: NAVBAR_MENU_KEYS.roles.candidate,
  Admin: NAVBAR_MENU_KEYS.roles.admin,
  User: NAVBAR_MENU_KEYS.roles.user,
};

export const translateRole = (t: TFunction, role: string): string => {
  const key = ROLE_KEY_MAP[role];
  return key ? t(key) : role;
};
